import React from "react";
import PropTypes from "prop-types";
import { Link, TextInput } from "@sia/style-guide";

const EnterMasterKeyView = ({ translate, enteredKey, invalidText, onEnteredKeyChange, onModeChange }) => (
  <div className="master-key-modal-content-inner">
    <TextInput id="master-key-input" onChange={(event) => onEnteredKeyChange(event.target.value)} value={enteredKey} autoFocus invalidText={invalidText} password label={translate("benchmarking.evaluations.master-key-modal.input-label")} />
    <div className="sia-padding-03-bottom"><Link withLeadIcon type="internal" target={() => onModeChange("change-key")}>{translate("benchmarking.evaluations.master-key-modal.change")}</Link></div>
    <div className="sia-padding-03-bottom"><Link withLeadIcon type="internal" target={() => onModeChange("reset-key")}>{translate("benchmarking.evaluations.master-key-modal.reset")}</Link></div>
    <div className="sia-padding-01-bottom">{translate("benchmarking.evaluations.master-key-modal.text")}</div>
  </div>
);

const ChangeMasterKeyView = ({ translate, oldKey, newKey, invalidText, invalidTextOldKey, onOldKeyChange, onNewKeyChange }) => (
  <div className="master-key-modal-content-inner">
    <TextInput id="old-master-key-input" onChange={(event) => onOldKeyChange(event.target.value)} value={oldKey} autoFocus invalidText={invalidTextOldKey} password label={translate("benchmarking.master-key-modal.old-key")} />
    <TextInput id="master-key-input" onChange={(event) => onNewKeyChange(event.target.value)} value={newKey} invalidText={invalidText} password label={translate("benchmarking.master-key-modal.new-key")} />
  </div>
);

const ResetMasterKeyView = ({ translate, newKey, invalidText, onNewKeyChange }) => (
  <div className="master-key-modal-content-inner">
    <TextInput id="master-key-input" onChange={(event) => onNewKeyChange(event.target.value)} value={newKey} autoFocus invalidText={invalidText} password label={translate("benchmarking.master-key-modal.new-key")} />
  </div>
);

const ConfirmNewKeyView = ({ translate, newKey }) => (
  <div className="master-key-modal-content-inner">
    <strong>{translate("benchmarking.master-key-modal.blurb.confirm-new-key")} {newKey}<br /></strong><br />
    {translate("benchmarking.master-key-modal.sublead.confirm-new-key")}
  </div>
);

const EvaluationsMasterKeyModalContent = (props) => {
  const { masterKeyMode } = props;
  let content = null;
  if (masterKeyMode === "enter-key") content = <EnterMasterKeyView {...props} />;
  else if (masterKeyMode === "change-key") content = <ChangeMasterKeyView {...props} />;
  else if (masterKeyMode === "reset-key") content = <ResetMasterKeyView {...props} />;
  else if (masterKeyMode === "confirm-new-key") content = <ConfirmNewKeyView {...props} />;
  return <div className="master-key-modal-content">{content}</div>;
};

const shared = { translate: PropTypes.func.isRequired, invalidText: PropTypes.string, onModeChange: PropTypes.func };
EnterMasterKeyView.propTypes = { ...shared, enteredKey: PropTypes.string.isRequired, onEnteredKeyChange: PropTypes.func.isRequired };
ChangeMasterKeyView.propTypes = { ...shared, oldKey: PropTypes.string.isRequired, newKey: PropTypes.string.isRequired, invalidTextOldKey: PropTypes.string, onOldKeyChange: PropTypes.func.isRequired, onNewKeyChange: PropTypes.func.isRequired };
ResetMasterKeyView.propTypes = { ...shared, newKey: PropTypes.string.isRequired, onNewKeyChange: PropTypes.func.isRequired };
ConfirmNewKeyView.propTypes = { translate: PropTypes.func.isRequired, newKey: PropTypes.string.isRequired };
EvaluationsMasterKeyModalContent.propTypes = {
  translate: PropTypes.func.isRequired,
  masterKeyMode: PropTypes.string.isRequired,
  enteredKey: PropTypes.string.isRequired,
  oldKey: PropTypes.string.isRequired,
  newKey: PropTypes.string.isRequired,
  invalidText: PropTypes.string.isRequired,
  invalidTextOldKey: PropTypes.string.isRequired,
  onEnteredKeyChange: PropTypes.func.isRequired,
  onOldKeyChange: PropTypes.func.isRequired,
  onNewKeyChange: PropTypes.func.isRequired,
  onModeChange: PropTypes.func.isRequired,
};

export default EvaluationsMasterKeyModalContent;
